import { notify } from '@billy/design-system'
import { TFunction } from 'i18next'

import { NotificationKeys } from '../../../../enums/notificationKeys'

export const notifyEmailSendError = (t: TFunction) =>
  notify({
    id: NotificationKeys.ExternalInvoiceSentAsEmail,
    message: t('external_invoices.send_as_email.notification.error'),
    variant: 'error',
  })
